import { ServiceIconSize } from "@zapier/design-system";
import { AppImages } from "../types";

const getAppIconUrl = (
  appId: string,
  images: AppImages | undefined,
  size: ServiceIconSize,
) => {
  let key;
  switch (size) {
    case 20: {
      key = "url_16x16" as const;
      break;
    }

    case 30: {
      key = "url_32x32" as const;
      break;
    }

    case 40: {
      key = "url_64x64" as const;
      break;
    }

    case 60: {
      key = "url_64x64" as const;
      break;
    }

    default: {
      key = "url_128x128" as const;
      break;
    }
  }

  const fallback = appId ? `/generated/${appId.replace("CLIAPI", "")}/64` : "";

  return images ? images[key] : fallback;
};

export default getAppIconUrl;
